import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=6de1ca2a&"
import script from "./UserData.vue?vue&type=script&lang=ts&"
export * from "./UserData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports